export default {"src":"/coding-school/_next/static/media/sidebar-icon.cc37919a.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};